(function() {

  // this setting enables the popup. to change the content of the popup itself
  // do that at the top of index.html. to disable it just set it to "false" (WITHOUT the quotes)
  var enablePopup = false; // dont write it with quotes, just true or false

  // this is a separate setting which will disable the "500K" coin limiter.
  // set it to false to disable the coin limiter
  var coinLimiterEnabled = false; // dont write it with quotes, just true or false

  

  var currentDiscountPercent = 0; // NOT USED ANYMORE............ put it back at 30 to re-enable

  window.coupMap = {
    coin: [

      /* COIN EXTRA DISCOUNT */

      {type: 'coins_percent', amount: 20, code: 'EXTRA20',   message: '20% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'EXTRA30',   message: '30% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'EXTRA35',   message: '35% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'EXTRA40',   message: '40% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 20, code: 'FREE20' ,   message: '20% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'FREE30',    message: '30% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'FREE35',    message: '35% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'FREE40',    message: '35% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'VIP50',     message: '35% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'EXTRA45',   message: '40% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'FREE50',    message: '40% Extra Coins Discount Added'},
      {type: 'coins_percent', amount: 30, code: 'EXTRA50',   message: '40% Extra Coins Discount Added'},

      /* COIN PERCENT DISCOUNT */

      {type: 'price_percent', amount: 10, code: 'MUT20',     message: '10% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'FLASH25',   message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'FLASH30',   message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'MIKE',      message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'GS',        message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'GS35',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'VICK25',    message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'ZIRK',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'ZIRKSEE',   message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MMG',       message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MMG50',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MUT15',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'GS30',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'NFL25',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'NFL30',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'NFL40',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'TOTW',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'NFL25',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MUT',       message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MUT25',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MUT30',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MUT35',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MUT40',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BACK20',    message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'CART',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BIG25',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BIG30',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'CC',        message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'TOKE',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'TD',        message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'VIC',       message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'SWIFT',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'GUTFOXX',   message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BACK35',    message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'MF25',      message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BACK30',    message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'NEW40',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BACK30',    message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'BF25',      message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'TURKEY',    message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'VIP35',  	 message: '35% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BIG25',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'NFL35',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 10, code: 'FLASH25',   message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 30, code: 'CYBER',     message: '30% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MF25',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'MASTER',    message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'DRAFT',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'XMAS',      message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'FLASH30',   message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'SUMMER',    message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'CHEAP',     message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'BOOM',      message: '15% Off Discount Added'},

    ],
    training: [

      /* TRAINING PERCENT DISCOUNT */

      {type: 'price_percent', amount: 10, code: 'MUT',     	 message: '10% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'PLAYERS20', message: '20% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'PLAYERS15', message: '15% Off Discount Added'},
      {type: 'price_percent', amount: 10, code: 'PLAYERS10', message: '10% Off Discount Added'},
      {type: 'price_percent', amount: 30, code: 'CYBER', 	 message: '30% Off Discount Added'},
      {type: 'price_percent', amount: 10, code: 'TRAIN20', 	 message: '20% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'PLAYERS30', message: '30% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'MF25', 	 message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'MIKE', 	 message: '30% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'PLAYERS25', message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 25, code: 'BF25',		 message: '25% Off Discount Added'},
      {type: 'price_percent', amount: 15, code: 'TRAIN15',   message: '15% Off Discount Added'}


    ],
  };

  










  window.activeDiscount = null;
  window.activeDiscountTraining = null;

  // SHOW DISCOUNT IF ENABLED

  if (currentDiscountPercent > 0) {
    $('.buy-now-discounted-confirm').show();
  }

  // POPUP

  if (enablePopup) {
    if (!Cookies.get('__sales_popup_shown')) {
      Cookies.set('__sales_popup_shown', '1', {path: '/', expires: 1});
      $('#sales_popup').popup({
        transition: 'all 0.3s'
      });
      setTimeout(function() {
        $('#sales_popup').popup('show');
      }, 1000);
    }
  }

  // PLAYER AUTOCOMPLETE

  $('#player-autocomplete').autocomplete({
    lookup: _playerNames,
    noCache: true
  });


  // BUY COINS PAGE SCROLL

  var scrollToOrder = function() {
    $('html, body').animate({
      scrollTop: $('.choose-system').offset().top - 52 // height of nav
    }, 500);
  };

  if (window.location.pathname === '/') {
    $('a[href="/#buy-coins"]').click(function(e) {
      e.preventDefault();
      scrollToOrder();
    });

    if (window.location.hash.match(/^#buy-coins/)) {
      setTimeout(function() {
        scrollToOrder();
      }, 250);
    }
  }


  // FAQ

  $('.faq .accordion h3').click(function() {
    var clicked = $(this);
    clicked.closest('.question').find('.answer').slideToggle(250);
  });

  // ORDER

  /* stores */

  var currentVariantIndex = null;

  /* helper functions */

  var numberWithCommas = function(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  var getSelectedSystem = function() {
    return $('#selected-system').val();
  };

  var getSelectedGame = function() {
    return $('#game-select').val();
  };

  var getCoinQuantity = function() {
    return parseInt($('#quantity-slider').val(), 10);
  };

  var getCurrentVariant = function() {
  	return _mrMeta[currentVariantIndex];
  };

  var setStartingPrice = function() {
    // 3000 to 9500 by 500
    var randomPrice = 3000 + (Math.floor(Math.random() * 13) * 500);
    $('#starting-price').val(numberWithCommas(randomPrice));
    $('#starting-price-confirm').text(numberWithCommas(randomPrice));
  };

  var noteElem = $('#order-note[name="note"]');
  var discountLabel = $('.buy-now-discounted-confirm');
  var setNoteText = function(amount) {
    var text = '';
    text += '10%: ' + numberWithCommas((amount * 1.10).toFixed(0)) + '\n';
    text += '15%: ' + numberWithCommas((amount * 1.15).toFixed(0)) + '\n';
    text += '20%: ' + numberWithCommas((amount * 1.20).toFixed(0)) + '\n';
    text += '25%: ' + numberWithCommas((amount * 1.25).toFixed(0)) + '\n';
    text += '30%: ' + numberWithCommas((amount * 1.30).toFixed(0)) + '\n';
    //text += '35%: ' + numberWithCommas((amount * 1.35).toFixed(0)) + '\n';
    text += '40%: ' + numberWithCommas((amount * 1.40).toFixed(0)) + '\n';
    //text += '45%: ' + numberWithCommas((amount * 1.45).toFixed(0)) + '\n';
    text += '50%: ' + numberWithCommas((amount * 1.50).toFixed(0)) + '\n';

    // TEMPORARILY DISABLE NOTES
    //noteElem.val(text);

    // also set the discount label in the checkbox confirm area
    if (currentDiscountPercent > 0) {
      var multiplier = 1.0 + (currentDiscountPercent / 100.0);
      var prettyAmount = numberWithCommas((amount * multiplier).toFixed(0));
      discountLabel.text(' (' + prettyAmount + ' with extra code)');
    }
  };

  var numberElem = $('#order-amount .number');
  var resizeNumberElem = function() {
    var width = numberElem.val().length;
    if (width < 6) { width = 6; }
    numberElem.css({width: (17 * width) + 'px'});
  };
  var setNumberElem = function(value) {
    var withCommas = numberWithCommas(value);
    numberElem.val(withCommas);
    resizeNumberElem();
  };

  var setInitialTptsDisplay = function() {
    var value = $('#tpts-system-select').val();
    $('.tpts-listing[data-show="' + value + '"]').show();
  };

  var setInitialQuicksellsDisplay = function() {
    var value = $('#quicksells-system-select').val();
    $('.quicksells-listing[data-show="' + value + '"]').show();
  };

  var setInitialScoutsDisplay = function() {
    var value = $('#scouts-system-select').val();
    $('.scouts-listing[data-show="' + value + '"]').show();
  };

  var quantitySlider = $('#quantity-slider');
  var forceUpdateAmount = function(amount) {
    quantitySlider.val(amount);
    quantitySlider.rangeslider('update', true);
  };

  var idElem = $('#variant-id');
  var setCurrentVariant = function() {
    var coinQuantity = getCoinQuantity();
    var winningIndex = null;
    var highestMin = 0;

    $.each(window._mrMeta, function(index, v) {
      if(v[2] === getSelectedSystem() && v[3] === getSelectedGame()) {
        if (v[5] <= coinQuantity && v[5] >= highestMin) {
          highestMin = v[5];
          winningIndex = index;
        }
      }
    });
  	currentVariantIndex = winningIndex;
    idElem.val(getCurrentVariant()[0]);
  };

  var quantityElem  = $('#quantity');
  var priceElem     = $('#order-amount .price');
  var priceDiscElem = $('#order-amount .price-discounted'); // also below (search)
  var perElem       = $('#order-amount .per-amount');
  var buyNowElem    = $('#buy-now-price');
  var buyNowConfirm = $('#buy-now-confirm');
  var BuyNowDiscMsg = $('#buy-now-discount-message'); // also below (search)
  var taxElem       = $('#after-taxes .amount');

  var updateQuantity = function(value) {
    setCurrentVariant();
    var price = getCurrentVariant()[4];
    var quantity = value / 10000;
    quantityElem.val(quantity);
    if (window.activeDiscount && window.activeDiscount.type === 'coins_percent') {
      var extraCoins = value * (window.activeDiscount.amount / 100.0);
      var buyNowNewAmount = value + extraCoins;
      BuyNowDiscMsg.show().html('+ <strong>' + numberWithCommas(extraCoins) + '</strong> extra coins added. List your player for <strong>' + numberWithCommas(buyNowNewAmount) + '</strong> buy now price');
      buyNowElem.val(numberWithCommas(buyNowNewAmount));
      buyNowConfirm.text(numberWithCommas(buyNowNewAmount));
    } else {
      buyNowElem.val(numberWithCommas(value));
      buyNowConfirm.text(numberWithCommas(value));
    }
    setNumberElem(value);
    if (window.activeDiscount && window.activeDiscount.type === 'price_percent') {
      var discountPrice = price * (1.00 - (window.activeDiscount.amount / 100.0));
      priceDiscElem.text('$' + numberWithCommas((discountPrice * quantity).toFixed(2)));
      priceElem.addClass('price-strike');
      priceElem.text('$' + numberWithCommas((price * quantity).toFixed(2)));
      perElem.text('($' + discountPrice.toFixed(2) + '/10K)');
    } else {
      priceElem.text('$' + numberWithCommas((price * quantity).toFixed(2)));
      perElem.text('($' + price.toFixed(2) + '/10K)');
    }
    taxElem.text(numberWithCommas(value * .90));
    setNoteText(value);
  };

  /* init */

  setStartingPrice();
  setInitialTptsDisplay();
  setInitialQuicksellsDisplay();
  setInitialScoutsDisplay();

  /* handle slider and quantity change */

  var rangeSliderElem = $('.order-details input[type="range"]');
  rangeSliderElem.rangeslider({
    polyfill: false,
    onSlide: function(position, value) {
      updateQuantity(value);
    }
  });

  var setMaxOfSlider = function(value) {
    var currentMax = parseInt(rangeSliderElem.prop('max'), 10);
    if (value > currentMax) {
      rangeSliderElem.prop('max', value);
      rangeSliderElem.rangeslider('update', true);
    }
  };

  /* swap both madden forms helpers */

  var swapForms = function() {
    var madden21PriorForm = $('.madden-21-prior-form');
    var madden22Form = $('.madden-22-form');
    // note that all the html refers to "madden22" to keep things simple but
    // really this applies to madden22, 23 and later games as well, so we are leaving
    // all the classes alone in html and only changing this conditional
    if (
      $('#game-select').val() === 'madden22' 
      || $('#game-select').val() === 'madden23' 
      || $('#game-select').val() === 'madden24'
      || $('#game-select').val() === 'madden25'
      || $('#game-select').val() === 'madden26'
      || $('#game-select').val() === 'madden27'
      
    ) {
      madden21PriorForm.hide();
      madden22Form.show();
    } else {
      madden22Form.hide();
      madden21PriorForm.show();
    }
  };

  /* change system buttons */

  $('.choose-system [data-value]').click(function(e) {
  	e.preventDefault();
    var clicked = $(this);
    var value = clicked.data('value');

    $('#selected-system').val(value);

    clicked.closest('.choose-system').find('[data-value]').removeClass('selected');
    clicked.addClass('selected');

    // NOTE: This is an annoying hack because when boi had me add College Football 25, he wanted them as 2 separate
    // buttons but didnt make it clear it was a different game. So we added it as a different system as a hack but didnt
    // change the game. the way it SHOULD have been done was 2 new coin products
    // added with the sku matching something like ps4_college25_100000 (ie.. only the game changing) but instead, an entire new system was added
    // as collegeps4_madden24_100000. instead of trying to fix this now with lots of people buying etc... we are going
    // to do a very dirty hack and simply change the label of the <option> for madden26 but still leave the option value as madden26...
    // this should be fine UNTIL a new college26 comes out or whatever... in which case we probably want to fix this. I
    // think the only thing you have to do to fix this is adding the actual REAL college25 input to the "game" dropdown,
    // then updating the skus for college 25 to point to that instead, then this label changing code can be deleted. Also,
    // you should search for anything with collegeps4/collegexboxone to make sure thats good. lastly, youll want to then
    // make the college PS4/college Xbox buttons NOT actually change the system like they normally do ....
    // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    // Optionally........................... if you want to try to do more label hacks to not have to do all that, theres
    // also nothing wrong with that either. TBH now that i think about this........... i might almost do this instead because
    // changing the label is just so easy
    // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    if (value === 'collegeps4' || value === 'collegexboxone') {
      $('#game-select option[value="madden24"]').text('College Football 27')
    } else {
      $('#game-select option[value="madden24"]').text('Madden 24')
    }

    const presetExpress = function() {
      if (!$('#express-toggle').is(':checked')) {
        $('#express-toggle').click();
      }
    }

    if (value === 'xboxone' || value === 'ps4' || value === 'pc' || value === 'collegeps4' || value === 'collegexboxone') {
      if (value === 'pc') {
        // dead game $('#game-select option[value="madden18"]').prop('disabled', true);
        $('#game-select option[value="madden19"]').prop('disabled', true);
        $('#game-select option[value="madden20"]').prop('disabled', true);
        $('#game-select option[value="madden21"]').prop('disabled', true);
        $('#game-select option[value="madden22"]').prop('disabled', true);
        $('#game-select option[value="madden23"]').prop('disabled', true);
        $('#game-select option[value="madden24"]').prop('disabled', true);
        $('#game-select option[value="madden25"]').prop('disabled', true);
        $('#game-select option[value="madden26"]').prop('disabled', true)
        // re-enable
        $('#game-select option[value="madden27"]').prop('disabled', false);
        $('#game-select').val('madden27');
        presetExpress();
      } else if (value === 'collegeps4' || value === 'collegexboxone') {
        // dead game $('#game-select option[value="madden18"]').prop('disabled', true);
        $('#game-select option[value="madden19"]').prop('disabled', true);
        $('#game-select option[value="madden20"]').prop('disabled', true);
        $('#game-select option[value="madden21"]').prop('disabled', true);
        $('#game-select option[value="madden22"]').prop('disabled', true);
        $('#game-select option[value="madden23"]').prop('disabled', true);
        // 24 intentionally missing, see below comment
        $('#game-select option[value="madden25"]').prop('disabled', true);
        $('#game-select option[value="madden26"]').prop('disabled', true);
        $('#game-select option[value="madden27"]').prop('disabled', true);
        // re-enable
        // NOTE you probably dont want to change this if adding a new game, read large comment above
        $('#game-select option[value="madden24"]').prop('disabled', false);
        $('#game-select').val('madden24');
        presetExpress();
      } else {
        // dead game $('#game-select option[value="madden18"]').prop('disabled', false);
        $('#game-select option[value="madden19"]').prop('disabled', false);
        $('#game-select option[value="madden20"]').prop('disabled', false);
        $('#game-select option[value="madden21"]').prop('disabled', false);
        $('#game-select option[value="madden22"]').prop('disabled', false);
        $('#game-select option[value="madden23"]').prop('disabled', false);
        $('#game-select option[value="madden24"]').prop('disabled', false);
        $('#game-select option[value="madden25"]').prop('disabled', false);
        $('#game-select option[value="madden26"]').prop('disabled', false);
        $('#game-select option[value="madden27"]').prop('disabled', false);
        presetExpress();
      }

      swapForms();
      setCurrentVariant();
      updateQuantity(getCoinQuantity());

      clicked.closest('form').find('.quicksells-details, .tpts-details, .scouts-details, .nba-details').hide();
      clicked.closest('form').find('.order-details').hide().show();
    } else if (value === 'quicksells') {
      clicked.closest('form').find('.tpts-details, .order-details, .scouts-details, .nba-details').hide();
      clicked.closest('form').find('.quicksells-details').show();
    } else if (value === 'tpts') {
      clicked.closest('form').find('.quicksells-details, .order-details, .scouts-details, .nba-details').hide();
      clicked.closest('form').find('.tpts-details').show();
    } else if (value === 'scouts') {
      clicked.closest('form').find('.quicksells-details, .order-details, .tpts-details, .nba-details').hide();
      clicked.closest('form').find('.scouts-details').show();
    } else if (value === 'nba') {
      clicked.closest('form').find('.quicksells-details, .order-details, .tpts-details, .scouts-details').hide();
      clicked.closest('form').find('.nba-details').show();
    }

    $('html, body').animate({
      scrollTop: $('#begin-details').offset().top - 52 // height of nav
    }, 500);
  });

  /* preset amounts */

  $('#preset-amounts a').click(function(e) {
    e.preventDefault();
    var amount = $(this).data('value');
    setMaxOfSlider(amount);
	forceUpdateAmount(amount);
  });

  /* name input */

  var getOverallClass = function(overall) {
    if (overall >= 80) {
      return 'red';
    } else if(overall >= 70) {
      return 'gold';
    } else if (overall >= 60) {
      return 'silver';
    } else {
      return '';
    }
  };

  var triggerSelectize = function() {
    $('select.player-name-selectize').not('select.selectized').selectize({
      valueField: 'v',
      searchField: ['n'],
      create: true,
      highlight: true,
      maxItems: 1,
      closeAfterSelect: true,
      lockOptgroupOrder: true,
      render: {
        option: function(item, escape) {
          return playerNameOption(item, escape);
        },
        item: function(item, escape) {
          return playerNameOption(item, escape);
        }
      },
      load: function(query, callback) {
        if (!query.length) return callback();
        $.getJSON('//www.mrmutcoin.com/cdn/shop/t/14/assets/players.json?v=30607693824962213761784446889').done(function(data) {
                  var items = [];
                  var q = query.toLowerCase();
        $.each(data, function(index, item) {
          if (!item.name.toLowerCase().includes(q)) {
            return;
          }
          items.push({
            n: item.name,
            o: item.overall,
            p: item.position,
            t: item.team,
            v: item.name + ' ' + item.overall.toString() + ' | ' + item.position
          });
        });
        callback(items);
      });
    }
                                          });
  };

  if ($('#player-name-select').length) {
    var playerNameOption = function(item, escape) {
      if (item.o && item.t && item.n && item.p) {
        // comes from file
        var overallClass = getOverallClass(item.o);
        return '<div class="option player-option">' +
          '  <span class="team team-' + escape(item.t) + '"></span>' +
          '  <span class="overall ovr-' + overallClass + '">' + escape(item.o).toString() + '</span>' +
          '  <span class="name">' + escape(item.n) + ' | ' + escape(item.p) + '</span>' +
          '</div>;';
      } else {
        // hand entered
        return '<div class="option player-option">' +
          '  <span class="name">' + escape(item.text) + '</span>' +
          '</div>;';
      }
    };

    triggerSelectize();
  }

  /* number input */

  numberElem.click(function() {
    $(this).select();
  });

  var parseNumberValue = function() {
    var str = numberElem.val().replace(/\D/g,'') || 0;
    return parseInt(str, 10);
  };

  numberElem.on('keyup keypress focus blur change', function() {
    var value = parseNumberValue();
    if (value > 10000000) {
      numberElem.addClass('error');
    } else {
      numberElem.removeClass('error');
      // we can't set the number here because of some very subtle
      // issue where entering amounts not % 10000 = 0 will cause the slider
      // to update to an amount OTHER than what they enter, so even if they
      // try to enter 720,000 (which is a multiple of 10K), they will have
      // to type 7200 to get to that, which is NOT a multiple of 10K, so
      // the slider will reset
    }
    resizeNumberElem();
  });

  numberElem.on('blur', function() {
    var value = parseNumberValue();

    // set to a multiple of 10K if not exact amount by rounding down
    value = Math.floor(value / 10000) * 10000;

    // reset extremes
    if (value > 10000000) {
      value = 10000000;
    } else if (value < 10000) {
      value = 10000;
    }

    // adjust max if necessary
    setMaxOfSlider(value);

    // remove leftover errors
    numberElem.removeClass('error');

    forceUpdateAmount(value);
    numberElem.val(numberWithCommas(value));
    resizeNumberElem();
  });

  /* change game */

  $('#game-select').change(function() {
    setCurrentVariant();
    updateQuantity(getCoinQuantity());
    swapForms();
  });

  /* madden 22+ form */

  $('#multiple-cards-add').click(function(e) {
    e.preventDefault();
    var count = $('#multiple-cards-form .card').length + 1;
    var html = $($('#multiple-cards-form .card:first').html());
    var card = $('<div class="card"></div>');
    card.append(html);
    card.find('.col1').html('<select class="player-name-selectize" name="properties[PlayerName' + count + ']" placeholder="Start typing name..." required></select>');
    card.find('input[name="properties[StartingPrice1]"]').attr('name', 'properties[StartingPrice' + count + ']');
    card.find('input[name="properties[BuyNowPrice1]"]').attr('name', 'properties[BuyNowPrice' + count + ']');
    $('#multiple-cards-form').append(card);
    triggerSelectize();
  });

  $('#express-toggle').change(function() {
    if ($('#express-toggle').is(':checked')) {
      $('.madden-22-non-express').hide();
    } else {
      $('.madden-22-non-express').show();
    }
  });

  /* COINS discount input box */

  $('#discount-code #discount-apply').click(function() {
    var entered = $('#discount-code input').val().trim();
    var couponFound = false;
    $.each(window.coupMap.coin, function(index, discount) {
      if (discount.code.toUpperCase() === entered.toUpperCase()) {
      	window.activeDiscount = discount;
        couponFound = true;
      }
    });
    if (couponFound) {
      $('#discount-code input').prop('readonly', true);
      $('#discount-code #discount-apply').hide();
      $('#discount-code #discount-clear').show();

      $('[name="return_to"]').val('/checkout/?discount=' + window.activeDiscount.code);
      $('#discount-code .discount-notice').text(window.activeDiscount.message).show();
      updateQuantity(getCoinQuantity());
    } else {
      alert('This is not a valid discount code');
    }
  });

  $('#discount-code #discount-clear').click(function() {
    window.activeDiscount = null;
    $('#discount-code input').val('');
    $('#discount-code input').prop('readonly', false);
    $('#discount-code #discount-apply').show();
    $('#discount-code #discount-clear').hide();
    $('[name="return_to"]').val('/checkout/');
    $('#discount-code .discount-notice').text('').hide();
    $('#buy-now-discount-message').text('').hide();
	$('#order-amount .price-discounted').text('');
    $('#order-amount .price').removeClass('price-strike');
    updateQuantity(getCoinQuantity());
  });

  /* TRAINING discount input box */

  var recomputeTpDiscounts = function() {
    // if theres no discount remove everything
    if (!window.activeDiscountTraining) {
      // undo price
      $('.tpts-listing .item').each(function() {
        $(this).find('.price').removeClass('price-strike');
        $(this).find('.price-discount').remove();
      });
      return;
    };
    // if discount already is shown and discount exists do nothing
    if ($('.tpts-listing .price-discount').length) return;
    // otherwise, add discount html
    var percent = (100 - window.activeDiscountTraining.amount) / 100;
    $('.tpts-listing .item').each(function() {
      var newPrice = (percent * parseFloat($(this).find('.price').text().replace(/[,$ ]/g, ''))).toFixed(2);
      $(this).find('.price').addClass('price-strike');
      $(this).append('<div class="price price-discount">$ ' + newPrice + '</div>');
    });
  };

  $('#discount-code-training #discount-apply-training').click(function() {
    var entered = $('#discount-code-training input').val().trim();
    var couponFound = false;
    $.each(window.coupMap.training, function(index, discount) {
      if (discount.code.toUpperCase() === entered.toUpperCase()) {
      	window.activeDiscountTraining = discount;
        couponFound = true;
      }
    });
    if (couponFound) {
      $('#discount-code-training input').prop('readonly', true);
      $('#discount-code-training #discount-apply-training').hide();
      $('#discount-code-training #discount-clear-training').show();

      $('[name="return_to"]').val('/checkout/?discount=' + window.activeDiscountTraining.code);
      $('#discount-code-training .discount-notice-training').text(window.activeDiscountTraining.message).show();
      recomputeTpDiscounts();
    } else {
      alert('This is not a valid discount code');
    }
  });

  $('#discount-code-training #discount-clear-training').click(function() {
    window.activeDiscountTraining = null;
    $('#discount-code-training input').val('');
    $('#discount-code-training input').prop('readonly', false);
    $('#discount-code-training #discount-apply-training').show();
    $('#discount-code-training #discount-clear-training').hide();
    $('[name="return_to"]').val('/checkout/');
    $('#discount-code-training .discount-notice-training').text('').hide();
    recomputeTpDiscounts();
  });

  /* quicksells */

  $('#quicksells-system-select').change(function() {
  	$('.quicksells-listing').hide();
    recomputeTpDiscounts();
    $('.quicksells-listing[data-show="' + $(this).val() + '"]').fadeIn(250);
  });

  var hasClickedQuicksellsListing = false;
  $('.quicksells-listing .item').click(function(e) {
    e.preventDefault();
    if (!$('#quicksells-system-select').val()) {
      alert('Choose PS4 or XB1 from the dropdown');
      return;
    }
    if (!$('#quicksells-notes').val().trim()) {
      $('#quicksells-notes').css({border: '3px solid #ff1f1f'});
      alert('Please fill in the Quicksells details box. Click the link if you need to learn more.');
      return;
    }
    if (!hasClickedQuicksellsListing) {
      hasClickedQuicksellsListing = true;
      $('#variant-id').val($(this).data('variant-id'));
      // override values in case they hit back
      $('#quantity').val(1);
      // remove junk
      noteElem.remove();
      //specifically remove coin inputs (but not quicksells note input)
      $('[name="properties[PlayerName]"]').remove();
      $('[name="properties[PlayerOverallRating]"]').remove();
      $('[name="properties[StartingPrice]"]').remove();
      $('[name="properties[BuyNowPrice]"]').remove();

      $(this).closest('form').submit();
    }
  });

  /* training points */

  $('#tpts-system-select').change(function() {
  	$('.tpts-listing').hide();
    recomputeTpDiscounts();
    $('.tpts-listing[data-show="' + $(this).val() + '"]').fadeIn(250);
  });

  var hasClickedTptsListing = false;
  $('.tpts-listing .item').click(function(e) {
    e.preventDefault();
    if (!$('#tpts-system-select').val()) {
      alert('Choose PS4 or XB1 from the dropdown');
      return;
    }
    if (!$('#tpts-notes').val().trim()) {
      $('#tpts-notes').css({border: '3px solid #ff1f1f'});
      alert('Please fill in the Training Points details box. Click the link if you need to learn more.');
      return;
    }
    if (!hasClickedTptsListing) {
      hasClickedTptsListing = true;
      $('#variant-id').val($(this).data('variant-id'));
      // override values in case they hit back
      $('#quantity').val(1);
      // remove junk
      noteElem.remove();
      //specifically remove coin inputs (but not tpts note input)
      $('[name="properties[PlayerName]"]').remove();
      $('[name="properties[PlayerOverallRating]"]').remove();
      $('[name="properties[StartingPrice]"]').remove();
      $('[name="properties[BuyNowPrice]"]').remove();

      $(this).closest('form').submit();
    }
  });

  /* scouts */

  $('#scouts-system-select').change(function() {
  	$('.scouts-listing').hide();
    $('.scouts-listing[data-show="' + $(this).val() + '"]').fadeIn(250);
  });

  var hasClickedScoutsListing = false;
  $('.scouts-listing .item').click(function(e) {
    e.preventDefault();
    if (!hasClickedScoutsListing) {
      hasClickedScoutsListing = true;
      $('#variant-id').val($(this).data('variant-id'));
      // override values in case they hit back
      $('#quantity').val(1);
      // remove junk
      noteElem.remove();
      //specifically remove coin inputs (but not scouts notes input)
      $('[name="properties[PlayerName]"]').remove();
      $('[name="properties[PlayerOverallRating]"]').remove();
      $('[name="properties[StartingPrice]"]').remove();
      $('[name="properties[BuyNowPrice]"]').remove();

      $(this).closest('form').submit();
    }
  });

  /* nba */

  $('#nba-qty-select').change(function() {
    var qty = $('#nba-qty-select').val();
    if (!qty) return;
    qty = parseInt(qty, 10);
    var html = $($('.nba-form-inner .card').first().html());
    $('.nba-form-inner .card').remove();
    for(var i = 0; i < qty; i++) {
      var card = $('<div class="card"></div>');
      $('.nba-form-inner').append(card);
      $('.nba-form-inner .card').last().append(html);
      $('.nba-form-inner .card').last().find('.col1 input').attr('name', $('.nba-form-inner .card').last().find('.col1 input').attr('name').replace('1', i + 1));
      var html = $($('.nba-form-inner .card').first().html());
    }
  });

  /* order submit */

  $('#order-coin-form').submit(function(e) {
    if ($('.choose-system a.choice-tpts').hasClass('selected')) {
      // training points
      // do nothing
    } else if ($('.choose-system a.choice-quicksells').hasClass('selected')) {
      // quicksells
      // do nothing
    } else if ($('.choose-system a.choice-scouts').hasClass('selected')) {
      // scouts
      // do nothing
    } else if ($('.choose-system a.choice-nba').hasClass('selected')) {
      // NBA
      var nbaProduct = $('#nba-system-select').val();
      var nbaQty = $('#nba-qty-select').val();
      if (!nbaProduct || !nbaQty) {
        alert('Please select a System and Quantity');
        return false;
      }
      var nbaerror = false;
      $('.nba-form-inner .col1 input').each(function() {
        if (!$(this).val()) {
          nbaerror = true;
        }
      });
      if (nbaerror) {
        alert('Please fill in all player names');
        return false;
      }
      // fill values
      $('#variant-id').val($('#nba-system-select').val());
      // add name=quantity to an input (we dont include it in the form becuase name=quantity already exists for the madden form)
      // we delete that field below tho so we can just add name to the select
      $('#nba-qty-select').attr('name', 'quantity');
      // remove all other fields
      $('#order-note').remove();
      $('.order-details').remove();
      $('.tpts-details').remove();
      $('.quicksells-details').remove();
    } else {
      // coins
      /* LIMITER - comment out if you don't want a restriction for max quantity */
      if (coinLimiterEnabled && ($('#game-select').val() === 'madden22' || $('#game-select').val() === 'madden23') && (parseNumberValue() > 500000)) {
        alert('Maximum quantity for Madden 22/23 coins is 500,000 for the first few days after launch.');
      	e.preventDefault();
        return false;
      }
      /* END LIMITER */

      if ($('.madden-22-form').is(':visible')) {
        var removeOtherFields = function() {
          $('[name="properties[KindlingNotes]"]').remove();
          $('[name="properties[properties[TptsNotes]]"]').remove();
          $('[name="properties[properties[QuicksellsNotes]]"]').remove();
          $('.nba-details').remove();
        };
        // MADDEN 22 EXPRESS
        if ($('#express-toggle').is(':checked')) {
          $('#order-coin-form').append($('<input type="hidden" name="properties[ExpressAmount]" value="' + numberWithCommas(parseNumberValue()) + '">'));
          $('#order-coin-form .button-next').prop('disabled', true);
          $('.madden-22-non-express').remove();
          $('.madden-21-prior-form').remove();
		  removeOtherFields();


        // MADDEN 22+ NON-EXPRESS
        } else {
          var formErrors = false;
          var numberError = false;
          $('#multiple-cards-form .card').each(function() {
            var name = $(this).find('select').val().trim();
            var start = $(this).find('.start-input').val().trim();
            var buy = $(this).find('.buy-input').val().trim();
            if (name && start && buy) return true; // skip good
            if (!name && !start && !buy) return true; // skip totally empty
            if (name && !start && !buy) return true; // skip name with no numbers
            formErrors = true;
          });
          var targetTotal = parseNumberValue();
          var currentTotal = 0;
          $('#multiple-cards-form .card').each(function() {
            var buyInput = $(this).find('.buy-input');
            if (buyInput.val() === '') return true;
            var number = parseInt(buyInput.val().replace(',', ''), 10);
            if (Number.isNaN(number)) {
              numberError = true;
              return false;
            }
            currentTotal += number;
          });
          if (numberError) {
            alert('Make sure all prices for each card are properly formatted using numbers only');
            e.preventDefault();
          } else if (currentTotal !== targetTotal) {
            alert('All Buy Now prices must total up to the number of coins you are buying: ' + numberWithCommas(targetTotal) + '. You currently have: ' + numberWithCommas(currentTotal) + '.');
            e.preventDefault();
          } else if (formErrors) {
            alert('All entered players must have a Name, Start Price, and Buy Now Price');
            e.preventDefault();
          } else {
            // successful madden 22 submit, remove all other inputs right before submitting
            $('#order-coin-form .button-next').prop('disabled', true);
            $('.madden-21-prior-form').remove();
            removeOtherFields();
          }
        }

      } else {
        // MADDEN 21 AND OLDER FORM
        if (!$('#player-name-select select').val().trim()) {
          alert("Make you select a Player and Overall. If it doesn't exist, you can create it.");
          e.preventDefault();
        } else if ($('#order-confirm-check').is(':checked')) {
          $('#order-coin-form .button-next').prop('disabled', true);
          $('.madden-22-form').remove();
        } else {
          alert('*** IMPORTANT ***\nYou must confirm the checkbox and read (and understand) the warning beside it. If you use the wrong information when listing your card, your order may be delayed.');
          e.preventDefault();
        }
      }
    }
  });

  /* player form */

  $('.player-form .buy-ps4').click(function() {
  	var form = $(this).closest('form');
    if (!form.find('select').val()) {
      alert('Please choose a player from the dropdown');
    } else {
      form.append('<input type="hidden" name="properties[PlayerConsole]" value="PS">');
      form.off('submit');
      form.submit();
    }
  });

  $('.player-form .buy-xb1').click(function() {
  	var form = $(this).closest('form');
    if (!form.find('select').val()) {
      alert('Please choose a player from the dropdown');
    } else {
      form.append('<input type="hidden" name="properties[PlayerConsole]" value="XB">');
      form.off('submit');
      form.submit();
    }
  });

  $('.player-form').submit(function(e) {
    e.preventDefault();
  });

  var playerOption = function(item, escape) {
    var parts = item.text.match(/^(.+)_____(.+)_____(.+)$/);
    var overallMatch = parts[1].match(/(.+) (\d\d)$/);
    if (overallMatch) {
      // "<player name> <overall>"
      var overall = overallMatch[2];
      var overallClass = getOverallClass(overall);
      var name = overallMatch[1];
    } else {
      // COMING SOON or some other product without an OVL after name
      var overall = null;
      var overallClass = '';
      var name = parts[1];
    }
    var price = parts[2];
    var url = parts[3];
    var hasImage = !/no-image/.test(url);
    return '<div class="option player-option image-' + hasImage + '">' +
           (hasImage ? ('<span class="photo" style="background-image: url(\'' + url + '\')"></span>') : '') +
           (overall ? ('<span class="overall ovr-' + overallClass + '">' + escape(overall) + '</span>') : '') +
           '  <span class="name">' + escape(name) + '</span>' +
           '  <span class="price"><span>&mdash;</span> ' + escape(price) + '</span>' +
           '</div>;';
  };


})();